<template>
    <div>
        <div class="sidebar-wrapper">
           <ul class="ul-sidebar">
            <li v-for="link in links" :key="link.id">
				<a class="" v-scroll-to="link.href">{{link.name}}</a>
            </li>
            
        </ul>
       
    </div>
</div>

</template>

<script>
   // import axios from 'axios'

   export default {
    name: 'scroll-to',
    
    props: {
        links: {
            Type: Object,
            required: true,
        }
    },
    }
</script>


<style scoped>
.ul-sidebar li a:before {
    content: "#";
    color: #42b983;
    position: absolute;
    left: -2px;
    margin-top: 3px;
    padding-right: 0.5em;
    font-size: 13px;
    line-height: 1;
    font-weight: bold;
}
.sidebar-wrapper {
    position: fixed;
    z-index: 10;
    width: 200px;
}
.ul-sidebar {
    height: 100%;

}
.ul-sidebar li {
    margin: 3px 0;
    box-sizing: border-box;
    width: 100%;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 400;
    font-style: normal;
    text-decoration: none;
    cursor: pointer;
    transition: background-color 125ms ease-out,color 125ms ease-out;
}
.ul-sidebar li a {
    background-color: transparent;
    color: #4b4b4b;
    display: inline-flex;
    min-height: 32px;
    width: 100%;
    padding: 5px 12px;
}
.ul-sidebar li a:hover {
    background-color: rgba(44,44,44,.06);
}

</style>


// WEBPACK FOOTER //
// src/components/layouts/ScrollTo.vue